import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../Auth/AuthContext';
import Login from '../Auth/Login/Login';
import Header from '../components/Header';

const RequireAdmin = ({ component: Component, allowedRoles }) => {
  const { authState } = useContext(AuthContext);
  const roles = authState?.user?.roles || [];
  const hasAccess = allowedRoles.some((r) => roles.includes(r));

  if (!authState?.token) {
    return <Login />;
  }
  if (!hasAccess) {
    return <Navigate to='/dashboard' replace />;
  }
  return (
    <>
      <Header />
      <div style={{ marginLeft: '56px' }}>
        <Component />
      </div>
    </>
  );
};

RequireAdmin.propTypes = {
  component: PropTypes.elementType.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

RequireAdmin.defaultProps = {
  allowedRoles: ['ROLE_ADMIN'],
};

export default RequireAdmin;
